import script from "./PlayerToolTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlayerToolTip.vue?vue&type=script&lang=ts&setup=true"

import "./PlayerToolTip.vue?vue&type=style&index=0&id=d8337cb8&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8337cb8"]])

export default __exports__